import { render, staticRenderFns } from "./ModalAvisos.vue?vue&type=template&id=2577abf8&scoped=true"
import script from "./ModalAvisos.vue?vue&type=script&lang=js"
export * from "./ModalAvisos.vue?vue&type=script&lang=js"
import style0 from "./ModalAvisos.vue?vue&type=style&index=0&id=2577abf8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2577abf8",
  null
  
)

export default component.exports